import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  LanguageCodeEnum,
  ShopSettingsTranslationInput
} from "../../types/globalTypes";
import TranslationsShopPage, {
  fieldNames
} from "../components/TranslationsShopPage";
import { TypedUpdateShopTranslations } from "../mutations";
import { TypedShopTranslationDetails } from "../queries";
import { UpdateShopTranslations } from "../types/UpdateShopTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsShopQueryParams {
  activeField: string;
}
export interface TranslationsShopProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsShopQueryParams;
}

const TranslationsShop: React.FC<TranslationsShopProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateShopTranslations) => {
    if (data.shopSettingsTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedShopTranslationDetails variables={{ id, language: languageCode }}>
      {shopTranslations => (
        <TypedUpdateShopTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: ShopSettingsTranslationInput = {};
              if (field === fieldNames.title) {
                input.title = data;
              } else if (field === fieldNames.description) {
                input.description = data;
              } else if (field === fieldNames.keywords) {
                input.keywords = data;
              } else if (field === fieldNames.headerText) {
                input.headerText = data;
              }
              updateTranslations({
                variables: {
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsShopPage
                activeField={params.activeField}
                disabled={
                  shopTranslations.loading || updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.shop, id)
                  )
                }
                onSubmit={handleSubmit}
                shop={maybe(() => shopTranslations.data.shopSetting)}
              />
            );
          }}
        </TypedUpdateShopTranslations>
      )}
    </TypedShopTranslationDetails>
  );
};
TranslationsShop.displayName = "TranslationsShop";
export default TranslationsShop;
